import { useRecoilState } from 'recoil';
import { KPI_FILTERS } from 'constants/kpiBuilderCatalogue';
import { builderAnswersState } from 'states';
import { source } from 'helpers/kpiBuilder/lookups';
import { toggleInList } from 'helpers/kpiBuilder/transitions';
import { BuilderSection } from './BuilderSection';
import { OptionCards } from './OptionCards';

// Filters tab in builder mode: tick the filters dashboard users get for this KPI.
export const BuilderFiltersTab = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const s = source(a);

  if (a.recipe === 'template') return <div className="col-sm-12 col-lg-8 mt-4 alert alert-light">The filters of the KPI you copied are kept. To change them, edit the copy as JSON.</div>;
  if (a.recipe === 'funnel') return <div className="col-sm-12 col-lg-8 mt-4 alert alert-light">A funnel has no filters of its own. Each step keeps the filters of the KPI it shows.</div>;
  if (!s) return <div className="col-sm-12 col-lg-8 mt-4 alert alert-light">Choose the data in the Data tab to see which filters are possible.</div>;

  const cards = KPI_FILTERS.map((f) => {
    const available = !!a.src && f.applies.includes(a.src);
    return { id: f.id, label: f.label, desc: available ? f.desc : `Not available for ${s.label.toLowerCase()}`, disabled: !available };
  });

  return (
    <div className="col-sm-12 col-md-12 col-lg-8 mt-4 mb-3 pb-5">
      <BuilderSection title="Filters for this visualization" hint="Filters give dashboard users a drop-down to narrow this chart themselves (for example to one competency). Tick only what they will need. Location filters (district, block, facility, institute) are controlled by the dashboard, not here.">
        <OptionCards cards={cards} selected={a.kpiFilters} onSelect={(id) => setA({ ...a, kpiFilters: toggleInList(a.kpiFilters, id) })} />
      </BuilderSection>
    </div>
  );
};
